module.exports = __webpack_public_path__ + "img/request-kits-four-six-weeks.0b6f23ec.png";